var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.103 27.4581C12.7344 27.4567 12.3705 27.3754 12.0365 27.2196C11.4909 26.9766 11.0527 26.5429 10.8041 25.9998C10.5556 25.4567 10.5137 24.8416 10.6865 24.2698L12.4426 18.4581H8.30485C7.77768 18.4587 7.25769 18.3358 6.78656 18.0993C6.31542 17.8628 5.90625 17.5192 5.59182 17.0961C5.27739 16.6729 5.06646 16.182 4.97592 15.6627C4.88539 15.1433 4.91777 14.61 5.07048 14.1054L8.47248 2.85544C8.67985 2.1596 9.1073 1.54979 9.69068 1.11753C10.2741 0.685264 10.9819 0.453866 11.708 0.458064H15.8626C16.3348 0.458459 16.7999 0.573181 17.2182 0.792425C17.6364 1.01167 17.9954 1.32892 18.2643 1.71706C18.5333 2.10519 18.7043 2.55268 18.7627 3.02128C18.8211 3.48988 18.7652 3.96565 18.5997 4.40794L16.7064 9.45806H19.583C20.1962 9.45802 20.7978 9.62502 21.3232 9.94115C21.8486 10.2573 22.278 10.7106 22.5652 11.2523C22.8524 11.7941 22.9865 12.4039 22.9533 13.0162C22.92 13.6284 22.7206 14.2201 22.3764 14.7276L15.1764 26.3151C14.9538 26.6636 14.6474 26.9509 14.2852 27.1506C13.923 27.3502 13.5166 27.4559 13.103 27.4581Z",
    fill: "#FFB21D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.458008 0.458008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroB);
export default __webpack_public_path__ + "static/media/astroB.a882f59ae794e72b0e65ff51adc97ee0.svg";
export { ForwardRef as ReactComponent };